export class ClientListItem {
  constructor(id, name, discount, email, phoneNumber, credit) {
    this.id = id;
    this.name = name;
    this.discount = discount;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.credit = credit;
  }

  get autocompleteLabel() {
    return `${this.id} - ${this.name}`;
  }
}
